export default "__VITE_ASSET__78d05a2c__"